// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"IY-z","subtitle":"JY-z","wrapper":"KY-z","leftArrow":"LY-z","rightArrow":"MY-z"};